import React, { useState, useEffect, useCallback, useImperativeHandle, forwardRef } from 'react';
import { ConnectButton as RainbowConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import WalletConnectModal from './WalletConnectModal';

export const ConnectButton = forwardRef(({ onAddressChange }, ref) => {
  const { address, isConnected } = useAccount();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [openConnectModalFn, setOpenConnectModalFn] = useState(null);
  const [manualAddress, setManualAddress] = useState(localStorage.getItem('bscAddress') || '');
  
  // 暴露方法给父组件
  useImperativeHandle(ref, () => ({
    openModal: handleOpenModal
  }));
  
  useEffect(() => {
    if (isConnected && address) {
      onAddressChange && onAddressChange(address);
      setManualAddress('');
    } else if (!isConnected) {
      const savedAddress = localStorage.getItem('bscAddress');
      if(savedAddress) {
        onAddressChange && onAddressChange(savedAddress);
        setManualAddress(savedAddress);
      } else {
        onAddressChange && onAddressChange('');
        setManualAddress('');
      }
    }
  }, [address, isConnected, onAddressChange]);

  const formatAddress = (address) => {
    if (!address) return '';
    return `0x${address.substring(2, 6)}...${address.substring(address.length - 4)}`;
  };

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  const handleSubmitAddress = (address) => {
    onAddressChange && onAddressChange(address);
    setManualAddress(address);
    localStorage.setItem('bscAddress', address);
    setIsModalOpen(false);
  };
  
  const handleConnectWallet = useCallback(() => {
    if (openConnectModalFn) {
      openConnectModalFn();
      setIsModalOpen(false);
    } else {
      console.error('openConnectModal function not available');
    }
  }, [openConnectModalFn]);
  
  return (
    <>
      <RainbowConnectButton.Custom>
        {({
          account,
          chain,
          openAccountModal,
          openChainModal,
          openConnectModal,
          authenticationStatus,
          mounted,
        }) => {
          const ready = mounted && authenticationStatus !== 'loading';
          
          const connected =
            ready &&
            account &&
            chain &&
            (!authenticationStatus || authenticationStatus === 'authenticated');
          
          setOpenConnectModalFn(() => openConnectModal);

          const hasManualAddress = !connected && manualAddress;

          return (
            <div
              {...(!ready && {
                'aria-hidden': true,
                style: {
                  opacity: 0,
                  pointerEvents: 'none',
                  userSelect: 'none',
                },
              })}
            >
              {(() => {
                if (!connected && !hasManualAddress) {
                  return (
                    <button 
                      onClick={handleOpenModal} 
                      className="w-full h-10 py-2 px-3 flex items-center justify-center rounded-[12px] border border-solid border-[rgba(247,132,255,0.5)] bg-[linear-gradient(161deg,#FFF_48.34%,rgba(255,255,255,0.00)_128.53%)] shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] text-[#f784ff] font-medium text-base transition-colors"
                    >
                      Connect Wallet
                    </button>
                  );
                }

                if (chain?.unsupported && !hasManualAddress) {
                  return (
                    <button 
                      onClick={openChainModal} 
                      className="w-full h-10 py-2 px-3 flex items-center justify-center rounded-[12px] border border-solid border-red-300 bg-[linear-gradient(161deg,#FFF_48.34%,rgba(255,255,255,0.00)_128.53%)] shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] text-red-500 font-medium text-base transition-colors"
                    >
                      wrong network
                    </button>
                  );
                }

                if (hasManualAddress) {
                  return (
                    <button 
                      onClick={handleOpenModal}
                      className="w-full h-10 py-2 px-3 flex items-center justify-center rounded-[12px] border border-solid border-[rgba(247,132,255,0.5)] bg-[linear-gradient(161deg,#FFF_48.34%,rgba(255,255,255,0.00)_128.53%)] shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] text-[#f784ff] font-medium text-base transition-colors"
                    >
                     {formatAddress(manualAddress)}
                    </button>
                  );
                }

                return (
                  <button 
                    onClick={openAccountModal}
                    className="w-full h-10 py-2 px-3 flex items-center justify-center rounded-[12px] border border-solid border-[rgba(247,132,255,0.5)] bg-[linear-gradient(161deg,#FFF_48.34%,rgba(255,255,255,0.00)_128.53%)] shadow-[0px_2px_3px_0px_rgba(204,205,207,0.15)] text-[#f784ff] font-medium text-base transition-colors"
                  >
                   {formatAddress(account.address)}
                  </button>
                );
              })()}
            </div>
          );
        }}
      </RainbowConnectButton.Custom>

      <WalletConnectModal 
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConnectWallet={handleConnectWallet}
        onSubmitAddress={handleSubmitAddress}
        initialAddress={manualAddress || ''}
      />
    </>
  );
}); 